import styled from 'styled-components';


export const HomeContainer = styled.div`
  background-color:#EBEBEE;
  height:100%;
  
`;
export const PriceHeader = styled.div`

color: #000;
font-family: Product Sans;
font-size: 42px;
font-style: normal;
font-weight: 700;
line-height: normal;
text-align:center;
padding-bottom:10px;
  
`;

export const FlexBox=styled.div`
  display:flex;  
  padding-top:30px;  
  align-items: center;
  justify-content: center;
  
`
export const ProfessionalBox=styled.div`

width: 304px;
height: 450px;
flex-shrink: 0;
border-radius: 24px;
background: #FFF6DC;

`
export const EnterpriseBox=styled.div`
margin-left:50px;
width: 366px;
height: 450px;
flex-shrink: 0;
border-radius: 24px;
background: #FFF;

`

export const EnterprisePlusBox=styled.div`
width: 304px;
height: 450px;
flex-shrink: 0;
border-radius: 24px;
background: #CEE1FF;
margin-left:50px;
`


export const BoxTitle=styled.div`
color: #000;
font-family: Product Sans;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding:20px;
  
`
export const BoxTitle2=styled.div`
color: #000;
font-family: Product Sans;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: normal;
width:50%;
height:45px;
vertical-align: bottom;
display: table-cell;
    padding-top: 21px;
    padding-left: 20px;
}
  
`

export const EnterpriseTitleBox=styled.div`
display:flex;
color: #000;
font-family: Product Sans;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: normal;

  
`


export const BoxContent=styled.div`
color: #595959;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 171.429% */
padding:0px 20px 0px 20px;
height:55%;
  
`
export const PriceBox=styled.div`
color: #000;
font-family: Product Sans;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding:20px 20px 20px 20px;
  
`
export const SelectPackage=styled.button`
display: flex;
width: 264px;
height: 48px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 10px;
flex-shrink: 0;
border-radius: 12px;
border:0px;
outline:none;
color: var(--light-theme-ffffff-100, #FFF);
text-align: center;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 150% */
text-transform: uppercase;
margin:auto;
cursor:pointer;

`

export const ImageBox=styled.div`
  width:50%;
  text-align:right;
  padding-right:50px
  
  
  
  
`

